(() => {
  const app = window.Ophira;
  if (!app) return;
  const { config, root, open, close, toast, canMove } = app;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  let cartBusy = false;
  let quickController;
  const variantControllers = new WeakMap();
  const checkedValues = new WeakMap();
  const stickyObservers = new WeakMap();
  async function request(path, options = {}) {
    const response = await fetch(path, { credentials: 'same-origin', ...options });
    let data;
    try { data = await response.json(); } catch { throw new Error(config.strings.error); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : data.message || config.strings.error);
    return data;
  }
  async function renderDrawer(html) {
    if (!html) {
      const sections = await request(`${root}?sections=cart-drawer`);
      html = sections['cart-drawer'];
    }
    if (!html) throw new Error(config.strings.error);
    const incoming = parse(html).querySelector('[data-cart-drawer]');
    const current = document.querySelector('[data-cart-drawer]');
    if (!incoming || !current) throw new Error(config.strings.error);
    current.replaceChildren(...Array.from(incoming.childNodes));
    const count = Number(current.querySelector('[data-drawer-count]')?.textContent || 0);
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = count; element.hidden = count === 0; });
    return current;
  }
  function animateBag(form) {
    if (!canMove()) return;
    const image = form.closest('[data-product-content]')?.querySelector('[data-gallery-main] img');
    const bag = document.querySelector('[data-cart-open]');
    if (!image || !bag) return;
    const from = image.getBoundingClientRect(), to = bag.getBoundingClientRect();
    const flyer = image.cloneNode(false);
    Object.assign(flyer.style, { position: 'fixed', top: `${from.top + from.height / 3}px`, left: `${from.left + from.width / 2 - 35}px`, width: '70px', height: '90px', objectFit: 'cover', zIndex: '99', pointerEvents: 'none', borderRadius: '3px' });
    document.body.append(flyer);
    const animation = flyer.animate([
      { transform: 'translate(0,0) scale(1)', opacity: .85 },
      { transform: `translate(${to.left - from.left - from.width / 2 + 45}px,${to.top - from.top - from.height / 3}px) scale(.15)`, opacity: .2 }
    ], { duration: 650, easing: 'cubic-bezier(.35,0,.25,1)' });
    animation.onfinish = () => flyer.remove();
  }
  function errorAt(context, message, selector = '[data-product-error]') {
    const element = context?.querySelector(selector);
    if (element) element.textContent = message;
    else toast(message);
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-product-form]')) return;
    event.preventDefault();
    if (cartBusy || form.dataset.variantLoading === 'true') return;
    cartBusy = true;
    const buttons = Array.from(document.querySelectorAll(`[form="${form.id}"], #${CSS.escape(form.id)} [type=submit]`));
    buttons.forEach(button => { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; });
    form.classList.add('is-loading'); form.setAttribute('aria-busy', 'true');
    errorAt(form, '');
    try {
      const data = new FormData(form);
      data.set('sections', 'cart-drawer'); data.set('sections_url', location.pathname);
      const response = await request(`${root}cart/add.js`, { method: 'POST', body: data });
      animateBag(form);
      const quick = document.getElementById('QuickDialog');
      if (quick?.open) close(quick);
      let drawer;
      try { drawer = await renderDrawer(response.sections?.['cart-drawer']); }
      catch { location.assign(`${root}cart`); return; }
      toast(config.strings.added);
      setTimeout(() => open(drawer, event.submitter || form.querySelector('[type=submit]')), canMove() ? 220 : 0);
    } catch (error) { errorAt(form, error.message); }
    finally {
      cartBusy = false; form.classList.remove('is-loading'); form.removeAttribute('aria-busy');
      buttons.forEach(button => { if (button.isConnected) button.disabled = button.dataset.wasDisabled === 'true'; });
    }
  });
  async function changeCart(line, quantity, origin) {
    if (cartBusy || !line) return;
    const input = line.querySelector('[data-cart-quantity]');
    const previous = Number(input.defaultValue);
    const next = Number(quantity);
    if (!Number.isInteger(next) || next < 0) { input.value = previous; return; }
    cartBusy = true;
    const drawer = line.closest('[data-cart-drawer]');
    const errorContext = drawer || line.closest('form');
    errorAt(errorContext, '', '[data-cart-error]');
    line.setAttribute('aria-busy', 'true');
    const controls = Array.from(errorContext?.querySelectorAll('button,input,[data-cart-remove]') || []);
    controls.forEach(control => { control.dataset.cartWasDisabled = String(control.disabled || false); if ('disabled' in control) control.disabled = true; });
    try {
      const data = await request(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity: next, sections: ['cart-drawer'], sections_url: location.pathname }) });
      if (!drawer) { location.reload(); return; }
      await renderDrawer(data.sections?.['cart-drawer']);
      const replacement = Array.from(drawer.querySelectorAll('[data-cart-line]')).find(item => item.dataset.key === line.dataset.key);
      if (origin?.matches('[data-cart-delta]')) replacement?.querySelector(`[data-cart-delta="${origin.dataset.cartDelta}"]`)?.focus({ preventScroll: true });
      else if (origin?.matches('[data-cart-quantity]')) replacement?.querySelector('[data-cart-quantity]')?.focus({ preventScroll: true });
      else drawer.querySelector('[data-close]')?.focus({ preventScroll: true });
      toast(config.strings.cart_updated);
    } catch (error) { input.value = previous; errorAt(errorContext, error.message, '[data-cart-error]'); }
    finally {
      cartBusy = false; line.removeAttribute('aria-busy');
      controls.forEach(control => { if (control.isConnected && 'disabled' in control) control.disabled = control.dataset.cartWasDisabled === 'true'; });
    }
  }
  document.addEventListener('click', async event => {
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) {
      event.preventDefault();
      const drawer = document.querySelector('[data-cart-drawer]');
      open(drawer, cartOpen);
      try { await renderDrawer(); } catch { close(drawer); location.assign(cartOpen.href); }
    }
    const remove = event.target.closest('[data-cart-remove]');
    const delta = event.target.closest('[data-cart-delta]');
    if (remove || delta) {
      event.preventDefault();
      const line = (remove || delta).closest('[data-cart-line]');
      const quantity = remove ? 0 : Number(line.querySelector('[data-cart-quantity]').value) + Number(delta.dataset.cartDelta);
      await changeCart(line, quantity, remove || delta);
    }
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('.quantity-control').querySelector('input');
      const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity, step = Number(input.step || 1);
      input.value = Math.max(min, Math.min(max, Number(input.value || min) + Number(stepper.dataset.quantityStep) * step));
    }
    const quickButton = event.target.closest('[data-quick-view]');
    if (quickButton) {
      quickController?.abort(); quickController = new AbortController();
      const controller = quickController;
      const dialog = document.getElementById('QuickDialog'), container = dialog.querySelector('[data-quick-content]');
      container.innerHTML = '<div class="loading-mark" aria-hidden="true">O.</div>';
      open(dialog, quickButton);
      try {
        const url = new URL(quickButton.dataset.quickView, location.origin); url.searchParams.set('section_id', 'quick-shop');
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(config.strings.error);
        const incoming = parse(await response.text()).querySelector('[data-product-content]');
        if (!incoming) throw new Error(config.strings.error);
        container.replaceChildren(incoming); init(container);
      } catch (error) {
        if (error.name !== 'AbortError') {
          container.replaceChildren(); const paragraph = document.createElement('p'); paragraph.className = 'drawer-pad'; paragraph.textContent = error.message; container.append(paragraph);
          const link = document.createElement('a'); link.className = 'text-link drawer-pad'; link.href = quickButton.dataset.quickView; link.textContent = config.strings.view_product; container.append(link);
        }
      }
    }
    const thumbnail = event.target.closest('[data-gallery-index]');
    if (thumbnail) selectMedia(thumbnail);
    const zoomImage = event.target.closest('[data-gallery-main] img');
    const zoomButton = event.target.closest('[data-gallery-zoom]');
    if (zoomImage || zoomButton) {
      const image = zoomImage || zoomButton.closest('[data-gallery-main]').querySelector('img');
      const dialog = document.getElementById('ZoomDialog');
      if (image && dialog) {
        const target = dialog.querySelector('[data-zoom-image]'); target.src = image.currentSrc || image.src; target.alt = image.alt;
        open(dialog, zoomButton || image);
      }
    }
  });
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-cart-quantity]')) await changeCart(event.target.closest('[data-cart-line]'), event.target.value, event.target);
    if (event.target.matches('[data-sort]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-option-value]')) await updateVariant(event.target);
  });
  async function updateVariant(input) {
    const product = input.closest('[data-product-content]');
    variantControllers.get(product)?.abort();
    const controller = new AbortController(); variantControllers.set(product, controller);
    const form = product.querySelector('[data-product-form]');
    if (form) form.dataset.variantLoading = 'true';
    product.setAttribute('aria-busy', 'true');
    const buttons = Array.from(product.querySelectorAll('[type=submit]'));
    buttons.forEach(button => { if (!button.hasAttribute('data-variant-was-disabled')) button.dataset.variantWasDisabled = String(button.disabled); button.disabled = true; });
    const values = Array.from(product.querySelectorAll('[data-option-value]:checked')).sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(value => value.value);
    try {
      const url = new URL(input.dataset.productUrl || product.dataset.productUrl, location.origin);
      url.searchParams.set('section_id', product.dataset.sectionId); url.searchParams.set('option_values', values.join(','));
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(config.strings.error);
      const incoming = parse(await response.text()).querySelector('[data-product-content]');
      if (!incoming || !product.isConnected) return;
      const optionPosition = input.dataset.optionPosition;
      stickyObservers.get(product)?.disconnect();
      product.replaceWith(incoming); init(incoming.parentElement);
      incoming.querySelector(`[data-option-position="${optionPosition}"]:checked`)?.focus({ preventScroll: true });
      if (!incoming.closest('dialog')) {
        const pageUrl = new URL(incoming.dataset.productUrl, location.origin);
        if (incoming.dataset.selectedVariant) pageUrl.searchParams.set('variant', incoming.dataset.selectedVariant);
        else pageUrl.searchParams.set('option_values', values.join(','));
        history.replaceState({}, '', pageUrl);
      }
      window.Shopify?.PaymentButton?.init?.();
    } catch (error) {
      if (error.name !== 'AbortError') {
        const previous = checkedValues.get(product) || [];
        product.querySelectorAll('[data-option-value]').forEach(option => { option.checked = previous.includes(option.value); });
        errorAt(form, error.message);
      }
    } finally {
      if (variantControllers.get(product) === controller) {
        product.removeAttribute('aria-busy');
        if (form) form.dataset.variantLoading = 'false';
        buttons.forEach(button => { if (button.isConnected) { button.disabled = button.dataset.variantWasDisabled === 'true'; delete button.dataset.variantWasDisabled; } });
      }
    }
  }
  function selectMedia(button) {
    const product = button.closest('[data-product-content]');
    const main = product.querySelector('[data-gallery-main]');
    const template = product.querySelector(`template[data-media-template="${button.dataset.galleryIndex}"]`);
    if (!template) return;
    main.querySelectorAll('video').forEach(video => video.pause());
    main.replaceChildren(template.content.cloneNode(true));
    installZoomButton(product);
    product.querySelectorAll('[data-gallery-index]').forEach(item => item.classList.toggle('is-active', item === button));
    if (canMove()) main.animate([{ opacity: .4 }, { opacity: 1 }], { duration: 250 });
  }
  function installZoomButton(product) {
    const main = product.querySelector('[data-gallery-main]');
    const template = product.querySelector('template[data-zoom-button]');
    if (main?.querySelector('img') && template && !main.querySelector('[data-gallery-zoom]')) main.append(template.content.cloneNode(true));
  }
  function init(context = document) {
    const products = Array.from(context.querySelectorAll('[data-product-content]'));
    if (context.matches?.('[data-product-content]')) products.unshift(context);
    products.forEach(product => {
      installZoomButton(product);
      checkedValues.set(product, Array.from(product.querySelectorAll('[data-option-value]:checked')).map(input => input.value));
      const sticky = product.querySelector('[data-sticky-buy]'), form = product.querySelector('[data-product-form]');
      if (sticky && form && 'IntersectionObserver' in window) {
        stickyObservers.get(product)?.disconnect();
        const observer = new IntersectionObserver(entries => entries.forEach(entry => sticky.classList.toggle('is-visible', !entry.isIntersecting)), { threshold: 0.05 });
        observer.observe(form); stickyObservers.set(product, observer);
      }
      const main = product.querySelector('[data-gallery-main]');
      if (main && !main.dataset.swipeBound) {
        main.dataset.swipeBound = 'true'; let touchX = 0, touchY = 0;
        main.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; touchY = event.touches[0].clientY; }, { passive: true });
        main.addEventListener('touchend', event => {
          const delta = event.changedTouches[0].clientX - touchX, vertical = event.changedTouches[0].clientY - touchY;
          if (Math.abs(delta) < 60 || Math.abs(delta) < Math.abs(vertical)) return;
          const thumbs = Array.from(product.querySelectorAll('[data-gallery-index]')); if (!thumbs.length) return;
          const active = thumbs.findIndex(thumb => thumb.classList.contains('is-active'));
          selectMedia(thumbs[(active + (delta < 0 ? 1 : -1) + thumbs.length) % thumbs.length]);
        }, { passive: true });
      }
    });
    app.initMotion(context); app.syncSaved();
    context.querySelectorAll('[data-recommendations]').forEach(element => {
      if (element.dataset.bound) return; element.dataset.bound = 'true';
      const load = async () => {
        try {
          const response = await fetch(element.dataset.url);
          if (!response.ok) return;
          const incoming = parse(await response.text()).querySelector('[data-recommendations-content]');
          if (incoming?.querySelector('.product-card')) { element.replaceChildren(incoming); app.initMotion(element); app.syncSaved(); }
        } catch {}
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, { rootMargin: '500px' }); observer.observe(element);
      } else load();
    });
  }
  let checkoutTimer;
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' || event.target.dataset.checkoutReady === 'true') return;
    if (cartBusy) { event.preventDefault(); return; }
    const overlay = document.querySelector('[data-checkout-transition]');
    if (!overlay) return;
    event.preventDefault();
    const form = event.target, submitter = event.submitter;
    overlay.classList.add('is-active'); overlay.setAttribute('aria-hidden', 'false');
    form.dataset.checkoutReady = 'true';
    setTimeout(() => {
      try { form.requestSubmit(submitter); } catch { resetCheckout(); location.assign(`${root}checkout`); }
    }, canMove() ? 350 : 0);
    clearTimeout(checkoutTimer);
    checkoutTimer = setTimeout(resetCheckout, 8000);
  });
  function resetCheckout() {
    clearTimeout(checkoutTimer);
    const overlay = document.querySelector('[data-checkout-transition]');
    overlay?.classList.remove('is-active'); overlay?.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-checkout-ready]').forEach(form => { delete form.dataset.checkoutReady; });
  }
  document.addEventListener('click', event => { if (event.target.closest('[data-cancel-checkout]')) resetCheckout(); });
  window.addEventListener('pageshow', resetCheckout);
  window.OphiraCommerce = { init, renderDrawer, updateVariant };
  init();
})();
